import React, { useEffect, useState } from "react";
import styles from "./AddEcomInventory.module.css";
import { AddEcomInventoryApi } from "../../Api/Ecom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {getCategoryList} from "../../Api/Ecom"
import { toast } from "react-toastify";
import AddCategoryModal from "./AddCategoryModal";

function AddEcomInventory() {
  const navigate = useNavigate();

  // const [images, setImages] = useState([]);
    const [vendorData, setVendorData] = useState({  images: [],
      specifications: [],  productName: '',
      categoryId: '',
      pricing: '',
      discountedPrice: '',
      description: '',
    isNew:''});
    const [openModal, setOpenModal] = useState(false);

  const [category, setCategory] = useState([]);
  const [rows, setRows] = useState([{ }]);

    const token = useSelector((state) => state.login.token);
    
  //image upload
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    
    if (files.length + vendorData.images.length > 4) { 
      alert("You can only upload up to 4 images");
      return;
    }

    const imagePreviews = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
      url: URL.createObjectURL(file)
    }));

    setVendorData(prev => ({
      ...prev,
      images: [...prev.images, ...imagePreviews]
    }));
  };

  const handleRemoveImage = (e, index) => {
    e.preventDefault()
    if (vendorData.images[index].preview) {
      URL.revokeObjectURL(vendorData.images[index].preview);
    }
    
    setVendorData(prev => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index)
    }));
  };

    
 // set specifivation title and detail

 
  const handleAddRow = (e) => {
    e.preventDefault();
    setVendorData(prev => ({
      ...prev,
      specifications: [...prev.specifications, { title:'' , detail:''}]
    }));
  };

  const handleRowChange = (index, field, value) => {
    setVendorData(prev => {
      const updatedSpecs = [...prev.specifications];
      updatedSpecs[index] = {
        ...updatedSpecs[index],
        [field]: value
      };
      return {
        ...prev,
        specifications: updatedSpecs
      };
    });
  };

  // change input data
  const handleChange = (event) => {
    const { name, value } = event.target;
      setVendorData((prev) => ({ ...prev, [name]: value }));
    };
    
  //category
  const fetchCategories = async () => {
      
      const categories = await getCategoryList(token);
      setCategory(categories.data);
    };
  useEffect(() => {
      fetchCategories()
  }, [])
    
    //createInventory
    const createInventory = async (e) => {
      e.preventDefault()
      try {
        const formData = new FormData();

        // Add basic data
        formData.append('productName', vendorData.productName);
        formData.append('categoryId', vendorData.categoryId);
        formData.append('pricing', vendorData.pricing);
        formData.append('discountedPrice', vendorData.discountedPrice);
        formData.append('description', vendorData.description);
        formData.append('isNew', vendorData.isNew);

  
        // Add specifications
        formData.append('specifications', JSON.stringify(vendorData.specifications));
  
        // Add images
        vendorData.images.forEach((image, index) => {
          if (image.file) {
            formData.append('productImages', image.file);
          }
        });
  
        const response = await AddEcomInventoryApi(token, formData);
        if(response.message === 'success'){  
          toast('Inventory created successfully!');
          navigate('/manageInventory');
        }
       
      } catch (error) {
        console.error('Error creating inventory:', error);
        alert('Failed to create inventory.');
    }
  };
  
  const updateCategoryData = () =>{
    fetchCategories();
  }
  // add category
  const handleAddCategory = (e) => {
    e.preventDefault();
    setOpenModal(true);
  }

  //close  category modal
  const handleCloseModal = () => {
    console.log('hvh')
    setOpenModal(false);
  }
  return (
   <div className={styles.container}>
      <div className={styles.formContainer}>
        <form>
          <div className={styles.section}>
            <h3>Product Info</h3>

            <div className={styles.inputGroup}>
              <label>Product Name</label>
              <input
                type="text"
                name="productName"
                value={vendorData.productName}
                onChange={handleChange}
              />
            </div>

            <div className={styles.inputGroup}>
              <label>Category</label>
              <div className={styles.categoryContainer}>

              <select
                className={styles.selectBox}
                name="categoryId"
                value={vendorData.categoryId || ''}
                onChange={handleChange}
                          >
                <option value="" disabled>
                  Select Category
                </option>
                {category.map((cat) => (
                  <option key={cat.categoryId} value={cat.categoryId}>
                    {cat.name}
                  </option>
                ))}
              </select>
              <button className={styles.addCategory} onClick={handleAddCategory}>Add New Category</button>  
                </div>
            </div>

              <label>Select Item Type</label>
            <div className={styles.selectType}>
              <div className={styles.checkboxContainer}>  
                <input type="checkbox" name="isNew" value={'true'} onChange={handleChange}></input>
                <p>new Item</p>
              </div>
              <div className={styles.checkboxContainer}>  
                <input type="checkbox" name="isNew" value={'false'} onChange={handleChange}></input>
                <p>used Item</p>
              </div>
            </div>
 
            <div className={styles.inputGroup}>
              <label>Product Media</label>
              <p className={styles.mediaNote}>You can add up to 4 images</p>
              <div className={styles.imageUpload}>
                {vendorData.images.map((img, index) => (
                  <div key={index} className={styles.previewImage}>
                        <img src={img.preview} alt={`Preview ${index + 1}`} />
                        <button className={styles.remove} onClick={(e) => handleRemoveImage(e,index)}>Remove</button>

                  </div>
                ))}
                {vendorData.images.length < 4 && (
                  <div className={styles.uploadButton}>
                    <input
                      type="file"
                      accept="image/*"
                      multiple
                      onChange={handleImageUpload}
                      name="productImages"
                    />
                    <span>Upload Image</span>
                  </div>
                )}
              </div>
            </div>

            <div className={styles.input}>
              <div>
                <label>Pricing</label>
                <input
                  type="number"
                  name="pricing"
                  value={vendorData.pricing}
                  onChange={handleChange}
                />
              </div>
              <div>
                <label>Discounted Price</label>
                <input
                  type="number"
                  name="discountedPrice"
                  value={vendorData.discountedPrice}
                  onChange={handleChange}
                />
              </div>
            </div>

            <div className={styles.inputGroup}>
              <label>Description</label>
              <textarea
                name="description"
                value={vendorData.description}
                onChange={handleChange}
              />
            </div>

            <div className={styles.productDetails}>
              <label>Product Details</label>
              <div className={styles.tabletitle}>
                <p>Title</p>
                <p>Detail</p>
              </div>
              <div className={styles.detailsTable}>
                {vendorData.specifications.map((row, index) => (
                  <div className={styles.detailRow} key={index}>
                    <div className={styles.detailTitle}>
                            <input
                                type="text"
                                value={row.title|| ''}
                            onChange={(e)=>handleRowChange(index,'title' , e.target.value)}
                            />
                    </div>
                    <div className={styles.detailValue}>
                            <input type="text"
                                value={row.detail|| ''}
                  onChange={(e)=>handleRowChange(index,'detail' , e.target.value)}
                            />

                    </div>
                  </div>
                ))}
                <button onClick={handleAddRow}>Add</button>
              </div>
            </div>
            <div className={styles.buttonGroup}>
              <button
                type="submit"
                className={styles.createButton}
                onClick={createInventory}
              >
                Create
              </button>
            </div>
          </div>
        </form>
      </div>
      <AddCategoryModal openModal={openModal} closeModal={handleCloseModal}  updateData={updateCategoryData}/>      
    </div>
  );
}

export default AddEcomInventory;
